import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import {
  apiRequest,
  recap360Summary,
  cancelToken
} from '../../../../../services/adapters/master/penialian360Service';

const StatCardsComponent = ({ data = null }) => {



  const [stats, setStats] = useState({
    totalPegawai: data?.totalPegawai ?? data?.total_pegawai ?? 0,
    sudahDinilai: data?.sudahDinilai ?? data?.sudah_dinilai ?? 0,
    belumDinilai: data?.belumDinilai ?? data?.belum_dinilai ?? 0,
    evaluasiSelesai: data?.evaluasiSelesai ?? data?.evaluasi_selesai ?? 0,
    persentase: data?.persentase ?? data?.persentase ?? 0,
  });

  useEffect(() => {
    let isMounted = true;
    const source = cancelToken();
    const queryParams = new URLSearchParams(window.location.search);
    const period_uuid = queryParams.get('uuid')
    const team_uuid = queryParams.get("team_uuid")

    apiRequest('get', recap360Summary, { params: { period_uuid: period_uuid, team_uuid: team_uuid  } }  , true)
      .then((res) => {
        if (!isMounted) return;
        const summary =
          res?.response?.summary ||
          res?.data?.summary ||
          res?.summary ||
          res?.data ||
          {};

        setStats({
          totalPegawai: summary.totalPegawai ?? summary.total_pegawai ?? 0,
          sudahDinilai: summary.sudahDinilai ?? summary.sudah_dinilai ?? 0,
          belumDinilai: summary.belumDinilai ?? summary.belum_dinilai ?? 0,
          evaluasiSelesai: summary.evaluasiSelesai ?? summary.evaluasi_selesai ?? 0,
          persentase: summary.persentase ?? summary.persentase ?? 0,
        });
      })
      .catch((err) => {
        if (!isMounted) return;
        console.error('Error fetching Recap360 summary:', err);
      });

    return () => {
      isMounted = false;
      source.cancel();
    };
  }, []);

  return (
    <Row className="mb-4 g-3">
      {/* Total Pegawai */}
      <Col xl={3} md={6}>
        <div className="p360-stat-card">
          <div>
            <div className="p360-stat-label">Total Pegawai</div>
            <div className="p360-stat-value">
              {stats.totalPegawai}
              <span className="p360-stat-unit">Pegawai</span>
            </div>
          </div>
          <div className="p360-stat-icon-wrapper blue">
            <i className="uil uil-users-alt"></i>
          </div>
        </div>
      </Col>

      {/* Sudah Dinilai */}
      <Col xl={3} md={6}>
        <div className="p360-stat-card">
          <div>
            <div className="p360-stat-label">Sudah Dinilai</div>
            <div className="p360-stat-value">
              {stats.sudahDinilai}
              <span className="p360-stat-unit">Pegawai</span>
            </div>
          </div>
          <div className="p360-stat-icon-wrapper green">
            <i className="uil uil-check-circle"></i>
          </div>
        </div>
      </Col>

      {/* Belum Dinilai */}
      <Col xl={3} md={6}>
        <div className="p360-stat-card">
          <div>
            <div className="p360-stat-label">Belum Dinilai</div>
            <div className="p360-stat-value">
              {stats.belumDinilai}
              <span className="p360-stat-unit">Pegawai</span>
            </div>
          </div>
          <div className="p360-stat-icon-wrapper orange">
            <i className="uil uil-clock"></i>
          </div>
        </div>
      </Col>

      {/* Evaluasi Selesai */}
      <Col xl={3} md={6}>
        <div className="p360-stat-card">
          <div>
            <div className="p360-stat-label">Persentase Progress</div>
            <div className="p360-stat-value">
              {parseFloat(stats.persentase).toFixed(2)}
              <span className="p360-stat-unit">%</span>
            </div>  
          </div>
          <div className="p360-stat-icon-wrapper purple">
            <i className="uil uil-chart-pie"></i>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default StatCardsComponent;
